<template>
  <div ref="dropdownRoot" style="position: relative">
    <div
      class="drop-down"
      :class="disabled ? 'disabled' : ''"
      @click="toggleDropdown"
    >
      <div>
        <p class="drop-down__title">{{ title }}</p>
        <p class="drop-down__option">{{ state.selected }}</p>
      </div>
      <div v-if="!disabled">
        <svg
          width="10"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.6"
            d="M8.29289 0.302766C8.68342 -0.100922 9.31658 -0.100922 9.70711 0.302766C10.0976 0.706454 10.0976 1.36096 9.70711 1.76465L5.70711 5.89948C5.31658 6.30317 4.68342 6.30317 4.29289 5.89948L0.292893 1.76465C-0.0976311 1.36096 -0.0976311 0.706454 0.292893 0.302766C0.683418 -0.100922 1.31658 -0.100922 1.70711 0.302766L5 3.70666L8.29289 0.302766Z"
            fill="#261940"
          />
        </svg>
      </div>
    </div>
    <DropdownOptions
      :options="options"
      :useModalDataToggle="useModalDataToggle"
      :showDropdown="state.showDropdown && !disabled"
      :searchable="searchable"
      :onSelected="onSelected"
    />
  </div>
</template>
<script>
import DropdownOptions from "@/components/dropdownoptions";
import {
  reactive,
  watch,
  ref,
  onMounted,
  onBeforeUnmount,
} from "@vue/composition-api";

const getDisplayValue = (label, options) => {
  if (!label) return "";
  const selected = (options || []).find(({ id }) => id === label);
  return selected ? selected.value : label;
};

export default {
  name: "Dropdown",
  setup(props) {
    const dropdownRoot = ref(null);
    const state = reactive({
      showDropdown: false,
      selected: getDisplayValue(props.label, props.options),
    });

    const toggleDropdown = () => {
      if (!props.disabled) state.showDropdown = !state.showDropdown;
    };

    const closeDropdown = () => {
      state.showDropdown = false;
    };

    const onDocumentClick = (event) => {
      if (!dropdownRoot.value || !state.showDropdown) return;
      if (!dropdownRoot.value.contains(event.target)) closeDropdown();
    };

    const onSelected = (id, value, payload = {}) => {
      state.selected = value;
      closeDropdown();
      props.onOptionSelected({ ...payload, id, value });
    };

    watch(
      () => [props.label, props.options],
      () => {
        state.selected = getDisplayValue(props.label, props.options);
      },
      { immediate: true }
    );

    onMounted(() => document.addEventListener("click", onDocumentClick));
    onBeforeUnmount(() =>
      document.removeEventListener("click", onDocumentClick)
    );

    return {
      dropdownRoot,
      state,
      toggleDropdown,
      onSelected,
    };
  },
  props: {
    options: Array,
    title: String,
    label: String,
    onOptionSelected: Function,
    disabled: Boolean,
    searchable: {
      type: Boolean,
      default: false,
    },
    useModalDataToggle: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    DropdownOptions,
  },
};
</script>
<style lang="scss">
.drop-down {
  background: #ffffff;
  border: 1px solid #cbd2d9;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  padding: 12.92px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  svg {
    cursor: pointer;
    width: 10px;
    height: 10px;
  }
  &__option {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 14px;
    color: #261940;
  }
  &__title {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #261940;
    opacity: 0.6;
    padding-bottom: 10px;
  }
}

.disabled {
  background: rgba(13, 72, 64, 0.05) !important;
}
</style>
